import { Injectable, Signal, inject } from '@angular/core';
import { CustomClaimsSchema, CustomClaims } from '@padspin/rbac';
import { CurrentIdTokenService } from '../current-id-token.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class CurrentClaimsService {
  private readonly idTokenService = inject(CurrentIdTokenService);

  readonly currentClaims: Signal<CustomClaims | null> = toSignal(
    this.currentClaims$(),
    { initialValue: null },
  );

  currentClaims$(): Observable<CustomClaims | null> {
    return this.idTokenService.currentUserIdToken$().pipe(
      map((idToken) => {
        if (!idToken) {
          return null;
        }
        const claims = CustomClaimsSchema.parse(idToken.claims);
        return claims;
      }),
    );
  }
}
